import $ from 'jquery';

$(function() {

    let $sliderImage = $('.slider-images');
    if ($sliderImage.length) {
        $sliderImage.slick({
            autoplay: true,
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            adaptiveHeight: true,
            nextArrow: '<button type="button" class="btn p-0 slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45"><path xmlns="http://www.w3.org/2000/svg" fill="#FFF" d="M30.719 21.078L17.532 8.086c-.793-.781-2.082-.781-2.875 0-.793.781-.793 2.051 0 2.832L26.413 22.5 14.657 34.082c-.793.781-.793 2.051 0 2.832.793.781 2.082.781 2.875 0l13.187-12.988c.402-.396.598-.913.593-1.422 0-.52-.195-1.034-.593-1.426z" transform="translate(-1715 -486) translate(0 294) translate(1715 192)"/></svg></button>',
            prevArrow: '<button type="button" class="btn p-0 slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45"><path xmlns="http://www.w3.org/2000/svg" fill="#FFF" d="M30.719 21.078L17.532 8.086c-.793-.781-2.082-.781-2.875 0-.793.781-.793 2.051 0 2.832L26.413 22.5 14.657 34.082c-.793.781-.793 2.051 0 2.832.793.781 2.082.781 2.875 0l13.187-12.988c.402-.396.598-.913.593-1.422 0-.52-.195-1.034-.593-1.426z" transform="translate(-160 -486) translate(0 294) translate(160 192) matrix(-1 0 0 1 45.375 0)"/></svg></button>',
        });
    }

    let $sliderMembership = $('.slider-membership');
    if ($sliderMembership.length) {
        let currentSlide;
        let slidesCount;
        let sliderCounter = $('#countNews')
        let sliderCounterWrapper = $('#counterWrapper')

        let updateSliderCounter = function(slick, currentIndex) {
            currentSlide = slick.slickCurrentSlide() + 1;
            slidesCount = slick.slideCount;
            $(sliderCounterWrapper).html('<span class="counter">' + currentSlide + '</span><span class="total">/' + slidesCount + '</span>')
        };

        $sliderMembership.on('init', function(event, slick) {
            $sliderMembership.append(sliderCounter);
            updateSliderCounter(slick);
        });

        $sliderMembership.on('afterChange', function(event, slick, currentSlide) {
            updateSliderCounter(slick, currentSlide);
        });

        $sliderMembership.slick({
            //autoplay: true,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            prevArrow: $('.previous'),
            nextArrow: $('.next'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }
            ]
        });
    }

    let $sliderProject = $('.slider-projects');
    if ($sliderProject.length) {
        let currentSlide;
        let slidesCount;
        let sliderCounter = $('#countNews')
        let sliderCounterWrapper = $('#counterWrapper')

        let updateSliderCounter = function(slick, currentIndex) {
            currentSlide = slick.slickCurrentSlide() + 1;
            slidesCount = slick.slideCount;
            $(sliderCounterWrapper).html('<span class="counter">' + currentSlide + '</span><span class="total">/' + slidesCount + '</span>')
        };

        $sliderProject.on('init', function(event, slick) {
            $sliderMembership.append(sliderCounter);
            updateSliderCounter(slick);
        });

        $sliderProject.on('afterChange', function(event, slick, currentSlide) {
            updateSliderCounter(slick, currentSlide);
        });

        $sliderProject.slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            prevArrow: $('.previous'),
            nextArrow: $('.next'),
        });
    }


});
